import React, { useState, useEffect, useRef } from 'react';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import Axios from '../../config/axios';
import { dateWithNoTimezone } from '../Helpers/DateFormat';
import { Fragment } from 'react';
import Moment from 'moment';
import DatePicker from 'react-datepicker';
import NumberFormat from 'react-number-format';
import { useForm, Controller } from "react-hook-form";
import Card from 'react-bootstrap/Card';
import { Tooltip, Popover, Select, Checkbox, List, message } from 'antd';
import { toast, confirm } from '@rickylandino/react-messages';
import SimpleSendEmailSlider from '../Email/SimpleSendEmailSlider';
import SelectContactsModal from '../Helpers/SelectContactsModal';

export default function ExhibitorFurnishingsSlider(props) {
    const [state, setState] = useState({
        showPane: false,
        dataLoaded: false
    });

    const { register, getValues, setValue, control, watch } = useForm();
    const userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
    const [viewOnly, setViewOnly] = useState([]);
    const [exhibitor, setExhibitor] = useState([]);

    useEffect(() => {
        if (userInfo.userType === 'admin') {
            setViewOnly(false);
        }
        else {
            setViewOnly(true);
        }

        setState({
            ...state,
            dataLoaded: true,
            showPane: true
        });

        setExhibitor(props.exhibitor);
        setValue("formFields", props.exhibitor);

    }, [props]);

    function handleSave() {

        //const values = getValues().formFields;

        //const updatedExhibitor = {
        //    ...exhibitor,
        //    table4: Number(values.table4),
        //    table6: Number(values.table6),
        //    table8: Number(values.table8),
        //    blackSkirt: Number(values.blackSkirt),
        //    blueSkirt: Number(values.blueSkirt),
        //    graySkirt: Number(values.graySkirt),
        //    whiteTop: Number(values.whiteTop),
        //    blackTop: Number(values.blackTop),
        //    easel1: values.easel1,
        //    easel2: values.easel2,
        //    easel3: values.easel3,
        //    easel4: values.easel4,
        //    easel5: values.easel5,
        //    easel6: values.easel6,
        //};

        //setExhibitor(updatedExhibitor);

        let postdata = {
            csvm: {
                id: props.exhibitor.id,
                table4: Number(getValues().formFields.table4),
                table6: Number(getValues().formFields.table6),
                table8: Number(getValues().formFields.table8),
                blackSkirt: Number(getValues().formFields.blackSkirt),
                blueSkirt: Number(getValues().formFields.blueSkirt),
                graySkirt: Number(getValues().formFields.graySkirt),
                whiteTop: Number(getValues().formFields.whiteTop),
                blackTop: Number(getValues().formFields.blackTop),
                easel1: getValues().formFields.easel1,
                easel2: getValues().formFields.easel2,
                easel3: getValues().formFields.easel3,
                easel4: getValues().formFields.easel4,
                easel5: getValues().formFields.easel5,
                easel6: getValues().formFields.easel6
            },

            userName: userInfo.userName
        };

        Axios.post(`/api/UpdateExhibitorBoothFurnishingsFromWebCM`, postdata
        ).then(response => {
            if (response.data) {
                let updatedExhibitor = response.data
                setExhibitor(updatedExhibitor)

                toast.success('Exhibitor Booth Furnishings Successfully Updated!');

                setState({
                    ...state,
                    showPane: false
                });

                setTimeout(() => {
                    if (props.furnishingsSliderCallingComponent === 'SuppliedServicesMgr') {
                        props.updateAllExhibitorsAfterSave();
                    }
                    else {
                        props.updateSingleExhibitorAfterSave(updatedExhibitor);
                    }

                    props.hidePane();
                }, 1000);
            }
        }).catch(error => {
            console.log(error);
        });
    }

    function handlePaneClose() {
        //if (JSON.stringify(getValues().formFields) !== JSON.stringify(getValues().originalFormFields)) {
        //    confirm({
        //        title: "Changes made to this show detail record will be lost",
        //        content: "Are you sure you would like continue?",
        //        buttons: ["Yes", "No"],
        //    }, (buttonPressed) => {
        //        if (buttonPressed === 'Yes') {
        //            hidePane();

        //            return 0;
        //        } else {
        //            return 0;
        //        }
        //    });
        //}
        //else {
        //    hidePane();
        //}

        hidePane();
    }

    function hidePane() {
        setState({
            ...state,
            showPane: false
        });

        setTimeout(() => {
            props.hidePane();
        }, 1000)
    }

    return (
        <>
            <SlidingPane
                className='my-custom-closer'
                overlayClassName='showCard'
                isOpen={state.showPane}
                title={'Exhibitor Furnishings for ' + props.exhibitor.name}
                onRequestClose={handlePaneClose}
                width={'40%'}
                closeIcon={<i className="fas fa-chevron-right float-left"></i>}
            >
                <div className="slide-pane-body scrollableDiv">
                    <div>
                        {state.dataLoaded &&
                            <div className="row mb-3">
                                {userInfo.userType !== 'admin' &&
                                    <h3 className="frame-heading mt-3">*** View Only Mode ***</h3>
                                }
                            
                                <div className="col-sm-12 col-md-6 col-xl-4">
                                    <Card className="d2pCard mb-3">
                                        <Card.Header><span>Tables</span></Card.Header>
                                        <Card.Body>
                                            <table>
                                                <tbody>
                                                    <tr><th style={{ verticalAlign: 'top' }}><label className="form-label">4 Foot:</label>&nbsp;</th><td style={{ width: '50%' }}><input type="number" step="1" min="0" name="table4" {...register("formFields.table4")} className="form-control-custom" disabled={viewOnly} /></td></tr>
                                                    <tr><th style={{ verticalAlign: 'top' }}><label className="form-label">6 Foot:</label>&nbsp;</th><td style={{ width: '50%' }}><input type="number" step="1" min="0" name="table6" {...register("formFields.table6")} className="form-control-custom" disabled={viewOnly} /></td></tr>
                                                    <tr><th style={{ verticalAlign: 'top' }}><label className="form-label">8 Foot:</label>&nbsp;</th><td style={{ width: '50%' }}><input type="number" step="1" min="0" name="table8" {...register("formFields.table8")} className="form-control-custom" disabled={viewOnly} /></td></tr>
                                                </tbody>
                                            </table>
                                        </Card.Body>
                                    </Card>
                                </div>
                                <div className="col-sm-12 col-md-6 col-xl-4">
                                    <Card className="d2pCard mb-3">
                                        <Card.Header><span>Tables Skirts</span></Card.Header>
                                        <Card.Body>
                                            <table>
                                                <tbody>
                                                    <tr><th style={{ verticalAlign: 'top' }}><label className="form-label">Black:</label>&nbsp;</th><td style={{ width: '50%' }}><input type="number" step="1" min="0" name="blackSkirt" {...register("formFields.blackSkirt")} className="form-control-custom" disabled={viewOnly} /></td></tr>
                                                    <tr><th style={{ verticalAlign: 'top' }}><label className="form-label">Royal Blue:</label>&nbsp;</th><td style={{ width: '50%' }}><input type="number" step="1" min="0" name="blueSkirt" {...register("formFields.blueSkirt")} className="form-control-custom" disabled={viewOnly} /></td></tr>
                                                    <tr><th style={{ verticalAlign: 'top' }}><label className="form-label">Gray:</label>&nbsp;</th><td style={{ width: '50%' }}><input type="number" step="1" min="0" name="graySkirt" {...register("formFields.graySkirt")} className="form-control-custom" disabled={viewOnly} /></td></tr>
                                                </tbody>
                                            </table>
                                        </Card.Body>
                                    </Card>
                                </div>
                                <div className="col-sm-12 col-md-6 col-xl-4">
                                    <Card className="d2pCard mb-3">
                                        <Card.Header><span>Tables Tops</span></Card.Header>
                                        <Card.Body>
                                            <table>
                                                <tbody>
                                                    <tr><th style={{ verticalAlign: 'top' }}><label className="form-label">White:</label>&nbsp;</th><td style={{ width: '50%' }}><input type="number" step="1" min="0" name="whiteTop" {...register("formFields.whiteTop")} className="form-control-custom" disabled={viewOnly} /></td></tr>
                                                    <tr><th style={{ verticalAlign: 'top' }}><label className="form-label">Black:</label>&nbsp;</th><td style={{ width: '50%' }}><input type="number" step="1" min="0" name="blackTop" {...register("formFields.blackTop")} className="form-control-custom" disabled={viewOnly} /></td></tr>
                                                </tbody>
                                            </table>
                                        </Card.Body>
                                    </Card>
                                </div>
                                <div className="col-12">
                                    <Card className="d2pCard mb-3">
                                        <Card.Header><span>Easels</span></Card.Header>
                                        <Card.Body>
                                            <table>
                                                <tbody>
                                                    <tr><th style={{ verticalAlign: 'top' }}><label className="form-label">Easel 1:</label>&nbsp;</th><td style={{ width: '90%' }}><input type="text" name="easel1" {...register("formFields.easel1")} className="form-control-custom" disabled={viewOnly} /></td></tr>
                                                    <tr><th style={{ verticalAlign: 'top' }}><label className="form-label">Easel 2:</label>&nbsp;</th><td><input type="text" name="easel2" {...register("formFields.easel2")} className="form-control-custom" disabled={viewOnly} /></td></tr>
                                                    <tr><th style={{ verticalAlign: 'top' }}><label className="form-label">Easel 3:</label>&nbsp;</th><td><input type="text" name="easel3" {...register("formFields.easel3")} className="form-control-custom" disabled={viewOnly} /></td></tr>
                                                    <tr><th style={{ verticalAlign: 'top' }}><label className="form-label">Easel 4:</label>&nbsp;</th><td><input type="text" name="easel4" {...register("formFields.easel4")} className="form-control-custom" disabled={viewOnly} /></td></tr>
                                                    <tr><th style={{ verticalAlign: 'top' }}><label className="form-label">Easel 5:</label>&nbsp;</th><td><input type="text" name="easel5" {...register("formFields.easel5")} className="form-control-custom" disabled={viewOnly} /></td></tr>
                                                    <tr><th style={{ verticalAlign: 'top' }}><label className="form-label">Easel 6:</label>&nbsp;</th><td><input type="text" name="easel6" {...register("formFields.easel6")} className="form-control-custom" disabled={viewOnly} /></td></tr>
                                                </tbody>
                                            </table>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                        }
                    </div>
                </div>

                <div className="modal-footer">
                    <div className="form-group col-12 padding-25-10">
                        {userInfo.userType === 'admin' &&
                            <button className="btn btn-submit me-3 float-right" onClick={handleSave}>Save</button>
                        }
                        <button className="btn btn-submit margin-left-15 float-right" onClick={handlePaneClose}>Close</button>

                        {userInfo.userType !== 'admin' &&
                                <span className="frame-heading mt-3 ms-3">*** View Only Mode ***</span>
                        }
                    </div>
                </div>
            </SlidingPane>
        </>
    );
}